'use strict';

var module = angular.module('AngularAdmin');

module.controller('AccountBusinessMembershipCtrl', require('./AccountBusinessMembershipCtrl.js'));
module.controller('AccountCtrl', require('./AccountCtrl.js'));
module.controller('CalendarNoteModalCtrl', require('./CalendarNoteModalCtrl.js'));
module.controller('CustomerOrderCalendarCtrl', require('./CustomerOrderCalendarCtrl.js'));
module.controller('DayViewCtrl', require('./DayViewCtrl.js'));
module.controller('MaterialDeleteModalCtrl', require('./MaterialDeleteModalCtrl.js'));
module.controller('MaterialModalCtrl', require('./MaterialModalCtrl.js'));
module.controller('MixDesignDeleteModalCtrl', require('./MixDesignDeleteModalCtrl.js'));
module.controller('NewEmployeeModalCtrl', require('./NewEmployeeModalCtrl.js'));
module.controller('ImportCustomersCtrl', require('./ImportCustomersCtrl.js'));
module.controller('OrderDeleteModalCtrl', require('./OrderDeleteModalCtrl.js'));
module.controller('OrderFieldsFormCtrl', require('./OrderFieldsFormCtrl.js'));
module.controller('OrderModalCtrl', require('./OrderModalCtrl.js'));
module.controller('OrderPlannerCtrl', require('./OrderPlannerCtrl.js'));
module.controller('OrderRequestsListCtrl', require('./OrderRequestsListCtrl.js'));
module.controller('OrdersBaseCalendarCtrl', require('./OrdersBaseCalendarCtrl.js'));
module.controller('OrdersCalendarCtrl', require('./OrdersCalendarCtrl.js'));
module.controller('OrdersListCtrl', require('./OrdersListCtrl.js'));
module.controller('ActivityListCtrl', require('./ActivityListCtrl.js'));
module.controller('PdPivotTable', require('./PivotTable.js'));
module.controller('PDCalendarCtrl', require('./PDCalendarCtrl.js'));
module.controller('PlantCtrl', require('./PlantCtrl.js'));
module.controller('PlantCustomersCtrl', require('./PlantCustomersCtrl.js'));
module.controller('PlantImportCustomersCtrl', require('./PlantImportCustomersCtrl.js'));
module.controller('PlantDetailsCtrl', require('./PlantDetailsCtrl.js'));
module.controller('PlantSubscribersCtrl', require('./PlantSubscribersCtrl.js'));
module.controller('ProductionCalendarCtrl', require('./ProductionCalendarCtrl.js'));
module.controller('ProductionForecastCtrl', require('./ProductionForecastCtrl.js'));
module.controller('ProductionModeDeleteModalCtrl', require('./ProductionModeDeleteModalCtrl.js'));
module.controller('ProductionScheduleEntryDeleteModalCtrl', require('./ProductionScheduleEntryDeleteModalCtrl.js'));
module.controller('ProductionScheduleEntryModalCtrl', require('./ProductionScheduleEntryModalCtrl.js'));
module.controller('ReferralCtrl', require('./ReferralCtrl.js'));
module.controller('RegistrationFormCtrl', require('./RegistrationFormCtrl.js'));
module.controller('ReportCtrl', require('./ReportCtrl.js'));
module.controller('RootCtrl', require('./RootCtrl.js'));
module.controller('ReportDateRangePicker', require('./ReportDateRangePicker.js'));
module.controller('ViewOrderRequestModalCtrl', require('./ViewOrderRequestModalCtrl.js'));
